module.exports = __webpack_public_path__ + "static/media/python.8fba8869.jpg";